export const TRANSPORT_TYPES = {
  meansTransportCar: {
    value: 1,
    label: "Voiture"
  },
  meansTransportMoto: {
    value: 2,
    label: "Moto"
  },
  meansTransportBike: {
    value: 3,
    label: "Vélo"
  },
  meansTransportPublicTransport: {
    value: 4,
    label: "Transport en commun"
  },
  meansTransportPermisB: {
    value: 5,
    label: "Permis B"
  }
};

export const MAX_CV_SIZE = 5 // 5MB

export const SALARY_TIME_UNIT = {
  MONTH: 1,
  HOUR: 2,
};